import {useShopId} from '@aboutyou/config';
import {Log as LogBase} from '@aboutyou/mlm';
import {useCallback} from 'react';
import {useLogInstanceId} from './useLogInstanceId';

export const useAuthLogger = () => {
  const shopId = useShopId();

  const {
    id: logInstanceId,
    isLogInstanceLoading,
    resetLoggerInstanceId,
  } = useLogInstanceId();

  const Log = useCallback(
    ({
      event,
      attributes = {},
      state,
    }: {
      event:
        | 'sso-open-url'
        | 'sso-cancelled-by-user'
        | 'sso-redirect'
        | 'sso-fe-error'
        | 'sso-success';
      attributes?: {
        idp?: string;
        idp_key?: string;
        reason?:
          | 'get-sso-buttons'
          | 'login-with-code'
          | 'redirect'
          | 'popup-stuck'
          | 'unknown';
        code?: number;
        error_detail?: `${string}:${string}`;
        error_stack_trace?: string;
        popup_communication_channel?: string;
      };
      state: string | null;
    }) => {
      const decodedState = getAttributesFromState(state);

      const log_instance_id = decodedState?.log_instance_id ?? logInstanceId;

      const idp_key = decodedState?.idpKey;
      const idp = decodedState?.idp;

      LogBase.unSampledLog(event, {
        feature: 'auth',
        method: 'sso',
        shop_id: shopId,
        event,
        log_instance_id,
        device: `${process.env.STACK}-web`,
        idp_key,
        idp,
        ...attributes,
      });
    },
    [shopId, logInstanceId],
  );

  return {
    Log,
    logInstanceId,
    isLogInstanceLoading,
    resetLoggerInstanceId,
  };
};

const getAttributesFromState = (state?: string | null) => {
  if (!state) {
    return null;
  }

  try {
    const decodedState = JSON.parse(atob(state)) as {
      idpKey?: string;
      idp?: string;
      log_instance_id?: string;
    };

    return decodedState;
  } catch (error) {
    return null;
  }
};
